import type { Cart } from "@dransay/api/models";

export const getAccessoryItemIds = (
	fulfillmentGroups: Cart["fulfillmentGroups"],
): Set<string> =>
	new Set(
		fulfillmentGroups
			.filter((group) => group.kind === "cross_selling")
			.flatMap((group) => group.itemIds),
	);

export const getAccessoryQuantity = (
	items: Cart["items"],
	accessoryItemIds: Set<string>,
): number =>
	items.reduce(
		(total, item) =>
			total + (accessoryItemIds.has(item.id) ? item.quantity : 0),
		0,
	);
